import React from 'react'
import { connect } from 'react-redux'
import { incCartQty, decCartQty } from '../redux/actions/cart'
import { formatPrice, subItemNames } from '../common/Functions';

function CartItem({ item, incCartQty, decCartQty, keyIndex }) {

    const dishtag = item.dish ? item.dish[0] : "";
    let dishClass = "";
    if (dishtag == 1) {
        dishClass = "veg";
    }

    if (dishtag == 2) {
        dishClass = "non-veg";
    }

    if (dishtag == 24) {
        dishClass = "egg";
    }

    if (item.size) {
        item.item_name += " - " + item.size;
    }



    return (
        <div className="added-item">
            <div className="left">
                <div className={"food-type " + (dishClass)}></div>
                <div className="item-details">
                    <p className="font-semibold">{item.item_name}</p>
                    {item.sub_item.sub_item_content && <p>{subItemNames(item.sub_item.sub_item_content)}</p>}
                    <p> {formatPrice(item.total_price_with_addons / item.qty)}</p>
                </div>
            </div>
            <div className="right">
                <div className="item-counter w-50">
                    <button className="btn-counter minus" onClick={() => decCartQty(keyIndex)}><span className="fa fa-minus"></span></button>
                    <button className="btn-counter plus" onClick={() => incCartQty(keyIndex)}><span className="fa fa-plus"></span></button>
                    <input type="text" value={item.qty} readOnly={true} />
                </div>
                <p className="total-price text-center w-50 "> {formatPrice(item.total_price_with_addons)}</p>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({})

export default connect(mapStateToProps, { incCartQty, decCartQty })(CartItem)
